/* eslint-disable no-void */

import { ApiResponse } from 'vopay';
import { useEffect, useState } from 'react';
import axios from 'axios';
import useDataFetchIndicator from '../useDataFetchIndicator';

import vopayApi from '../../services/api.config';

const hook = vopayApi.withApiHook(({ api }) => {
  return function usePostInterestAccount() {
    const source = axios.CancelToken.source();
    const [, setDataFetchingInfo] = useDataFetchIndicator();

    const [response, setResponse] = useState<ApiResponse>({
      ErrorMessage: '',
      Success: false,
    });
    const postInterestAccount = async () => {
      try {
        setDataFetchingInfo(true, 'loading some data', 'fullScreen');

        const res = await api.postInterestAccount(source);
        setResponse(res);
        return res;
      } finally {
        setDataFetchingInfo(false);
      }
    };

    useEffect(() => {
      return () => {
        source.cancel();
      };
    }, []);

    return {
      response,
      postInterestAccount,
    };
  };
});

export default hook({});
